import { Icon, Theme, Tooltip, withStyles } from "@material-ui/core";
import React from "react";
import { IErrorMessageJsonData } from "./RequestControl";

const HtmlTooltip = withStyles((theme: Theme) => ({
	tooltip: {
		backgroundColor: '#fdecea',
		color: '#611a15',
		padding: "6px 16px",
		fontSize: "14px",
		maxWidth: 250,
		border: '1px solid #fdecea',
	},
}))(Tooltip);

export function ErrorMessagesIconTooltip(props: { errorMessages: IErrorMessageJsonData[] }) {

	if (!props.errorMessages || props.errorMessages.length == 0)
		return null;

	return <HtmlTooltip
		title={
			<ul>
				{props.errorMessages.map((x, i) => <li key={i}>{x.errorMessage}</li>)}
			</ul>
		}
	>
		<Icon style={{ color: "#f44336", cursor: "pointer" }} >error</Icon>
	</HtmlTooltip>
}


export function ErrorMessagesList(props: { errorMessages: IErrorMessageJsonData[] }) {
	if (!props.errorMessages || props.errorMessages.length == 0)
		return null;

	return <ul>
		{props.errorMessages.map((x, i) => <li key={i} style={{ color: "#f44336" }}>{x.errorMessage}</li>)}
	</ul>
}